// extracted by mini-css-extract-plugin
export default {"CalendarWidget":"CalendarWidget_CalendarWidget__ZtSum","CalendarWidgetContent":"CalendarWidget_CalendarWidgetContent__Gf85i"};